import React, { useState } from 'react';
import Logo from '../../assets/Logo.png';
import { Link, useNavigate } from 'react-router-dom'; 
import { useCart } from '../../Context/CartContext';
import './Header.css';

// --- CLOSE ICON ---
const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

// --- HAMBURGER ICON ---
const HamburgerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const Header = () => {
  const { itemCount, openCart, openLogin, currentUser, logout, openSearch } = useCart(); 
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
  const navigate = useNavigate(); 

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileCategoryOpen(false);
  };
  
  const toggleMobileCategory = () => {
    setIsMobileCategoryOpen(!isMobileCategoryOpen);
  };
  
  const handleLoginClick = (e) => {
    e.preventDefault(); 
    closeMobileMenu();
    
    if (currentUser) {
      navigate('/my-account'); 
    } else {
      setTimeout(() => {
        openLogin(); 
      }, 300);
    }
  };

  const handleLogoutClick = (e) => {
    e.preventDefault();
    closeMobileMenu();
    logout();
  };
  
  const handleAccountIconClick = () => {
    if (currentUser) {
      navigate('/my-account'); 
    } else {
      openLogin(); 
    }
  };

  return (
    <>
      {isMobileMenuOpen && (
        <div className="mobile-menu-backdrop" onClick={closeMobileMenu}></div>
      )}

      <div className="top-strip announcement-bar">
        <div className="announcement-track">
          <span> GET EXTRA 5% OFF ABOVE ₹2000 WITH CODE SAVE5! </span>
          <span className="separator">&bull;</span>
          <span>FREE SHIPPING ON ALL APPAREL</span>
          
          <span className="separator">&bull;</span>
          <span>GET EXTRA 5% OFF ABOVE ₹2000 WITH CODE SAVE5!</span>
          <span className="separator">&bull;</span>
          <span>FREE SHIPPING ON ALL APPAREL</span>

          <span className="separator">&bull;</span>
          <span>GET EXTRA 5% OFF ABOVE ₹2000 WITH CODE SAVE5!</span>
          <span className="separator">&bull;</span>
          <span>FREE SHIPPING ON ALL APPAREL</span>

          <span className="separator">&bull;</span>
          <span>GET EXTRA 5% OFF ABOVE ₹2000 WITH CODE SAVE5!</span>
          <span className="separator">&bull;</span>
          <span>FREE SHIPPING ON ALL APPAREL</span>
        </div>
      </div>

      <header className="site-header">
        <div className="header-inner">
          <div className="container">
            <div className="logo">
              <Link to="/">
                {Logo && (
                  <img 
                    src={Logo} 
                    alt="ChawalTaka Logo" 
                    className="logo-img"
                    width="179" 
                    height="64"
                    fetchPriority="high"
                  />
                )}
              </Link>
            </div>
          
            <nav className="main-nav" aria-label="Main navigation">
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><a href="/#bestsellers">Bestsellers</a></li>
                <li><Link to="/shop-all">Shop All</Link></li>
                <li className="has-dropdown">
                  <a href="/">Categories</a>
                  <ul className="nav-dropdown" aria-label="Categories submenu">
                    <li><Link to="/category/dresses">Dresses</Link></li>
                    <li><Link to="/category/new-arrivals">New Arrivals</Link></li>
                    <li><Link to="/category/top-wear">Top wear</Link></li>
                    <li><Link to="/category/bottom-wear">Bottom wear</Link></li>
                    <li><Link to="/category/classy-indie">Classy indie</Link></li>
                    <li><Link to="/accessories">Accessories</Link></li>

                  </ul>
                </li>
                {/* --- ADDED BLOG LINK --- */}
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact-us">Contact us</Link></li>
              </ul>
            </nav>

            <div 
              className={`mobile-nav-container ${isMobileMenuOpen ? 'is-open' : ''}`}
              aria-hidden={!isMobileMenuOpen} 
            >
              <div className="mobile-nav-header">
                <button onClick={closeMobileMenu} className="mobile-nav-close-btn" aria-label="Close menu">
                  <CloseIcon />
                </button>
              </div>
              <nav className="mobile-nav-links" aria-label="Mobile navigation">
                <ul>
                  <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
                  <li><a href="/#bestsellers" onClick={closeMobileMenu}>Bestsellers</a></li>
                  <li><Link to="/shop-all" onClick={closeMobileMenu}>Shop All</Link></li>
                  
                  <li className="has-dropdown-mobile">
                    <span className="mobile-category-label" onClick={toggleMobileCategory}>
                      Categories
                    </span>
                    <span className="plus-icon" onClick={toggleMobileCategory}>
                      {isMobileCategoryOpen ? '−' : '+'}
                    </span>
                  </li>
                  
                  {isMobileCategoryOpen && (
                    <ul className="mobile-nav-dropdown">
                      <li><Link to="/category/dresses" onClick={closeMobileMenu}>Dresses</Link></li>
                      <li><Link to="/category/new-arrivals" onClick={closeMobileMenu}>New Arrivals</Link></li>
                      <li><Link to="/category/top-wear" onClick={closeMobileMenu}>Top Wear</Link></li>
                      <li><Link to="/category/bottom-wear" onClick={closeMobileMenu}>Bottom Wear</Link></li>
                      <li><Link to="/category/classy-indie" onClick={closeMobileMenu}>Classy indie</Link></li>
                      <li><Link to="/accessories" onClick={closeMobileMenu}>Accessories</Link></li>
                    </ul>
                  )}
                  {/* --- ADDED BLOG LINK FOR MOBILE --- */}
                  <li><Link to="/blog" onClick={closeMobileMenu}>Blog</Link></li>
                  <li><Link to="/contact-us" onClick={closeMobileMenu}>Contact us</Link></li>
                  
                  {currentUser && (
                     <li><Link to="/my-account" onClick={closeMobileMenu}>My Account</Link></li>
                  )}
                </ul>
              </nav>
              <div className="mobile-nav-footer">
                
                {currentUser ? (
                  <button type="button" className="mobile-nav-login" onClick={handleLogoutClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                    <span>Log out</span>
                  </button>
                ) : (
                  <button type="button" className="mobile-nav-login" onClick={handleLoginClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    <span>Log in</span>
                  </button>
                )}
              </div>
            </div>

            <div className="header-icons">
              <button className="icon-btn" aria-label="Search" title="Search" onClick={openSearch}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zM10 15a5 5 0 110-10 5 5 0 010 10z" />
                </svg>
              </button>
              
              {currentUser ? (
                <Link to="/my-account" className="icon-btn desktop-only-icon" aria-label="My Account" title="My Account">
                   <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8V22h19.2v-2.8c0-3.2-6.4-4.8-9.6-4.8z" />
                  </svg>
                </Link> 
              ) : (
                <button className="icon-btn desktop-only-icon" aria-label="Account" title="Account" onClick={handleAccountIconClick}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8V22h19.2v-2.8c0-3.2-6.4-4.8-9.6-4.8z" />
                  </svg>
                </button> 
              )}
              
              <button onClick={openCart} className="icon-btn cart-icon-wrapper" aria-label="Cart" title="Cart">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 2-2-.9-2-2-2zM7.16 6l.8 2h8.45c.75 0 1.41.41 1.75 1.03L21 16H7V6h.16zM6 2h2l1.2 3H20v2H9.8L8.3 7H6V2z" />
                </svg>
                {itemCount > 0 && (
                  <span className="cart-badge">{itemCount}</span>
                )}
              </button>
            </div>
            
            <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
              {isMobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
            </button>

          </div>
        </div>
      </header>
    </>
  );
};

export default Header;